import { Alert, Box, Container, Divider, FormControlLabel, Grid2 as Grid, Paper, Switch, Typography } from '@mui/material'
import * as React from 'react'

import ContactCard from '../components/cards/ContactCard'

export default function DevContactCard() {
  const [showEmergencyContact, setShowEmergencyContact] = React.useState(true)

  // 示例用户数据
  const sampleUsers = [
    {
      resourceId: 'user-001',
      name: '王小明',
      email: 'xiaoming@example.com',
      phone: '138-8888-8888',
      avatar: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
      weChatId: 'wx_xiaoming',
      emergencyContact: {
        name: '王大明',
        phone: '139-9999-9999',
        relationship: '父亲',
      },
    },
    {
      resourceId: 'user-002',
      name: '李小红',
      email: 'xiaohong@example.com',
      phone: '137-7777-7777',
      avatar: 'https://www.gravatar.com/avatar/305e460b479e2e5b48aec07710c08d51',
      emergencyContact: {
        name: '李女士',
        phone: '136-6666-6666',
        relationship: '母亲',
      },
    },
    {
      resourceId: 'user-003',
      name: '张教练',
      email: 'zhang@example.com',
      phone: '135-5555-5555',
      weChatId: 'coach_zhang',
      emergencyContact: {
        name: '张太太',
        phone: '134-4444-4444',
        relationship: '配偶',
      },
    },
    {
      resourceId: 'user-004',
      name: '刘新手',
      email: 'liu@example.com',
      // 没有电话号码
      emergencyContact: {
        name: '刘先生',
        phone: '133-3333-3333',
        relationship: '兄弟',
      },
    },
  ]

  return (
    <Container maxWidth="100%">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          联系人卡片组件展示
        </Typography>

        <Paper sx={{ p: 2, mb: 4 }}>
          <Alert severity="info" sx={{ mb: 2 }}>
            紧急联系人信息现在默认折叠，点击卡片上的"Emergency Contact"按钮可以展开查看详细信息。
          </Alert>
          <FormControlLabel control={<Switch checked={showEmergencyContact} onChange={(e) => setShowEmergencyContact(e.target.checked)} />} label="包含紧急联系人信息选项" />
        </Paper>

        {/* 大尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          大尺寸卡片
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          点击"Emergency Contact"按钮可以展开查看紧急联系人详细信息
        </Typography>
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {sampleUsers.slice(0, 2).map((user) => (
            <Grid size={{ xs: 12, md: 6 }} key={user.resourceId}>
              <ContactCard user={user} size="large" emergencyContact={showEmergencyContact} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 中等尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          中等尺寸卡片
        </Typography>
        <Grid container spacing={3} sx={{ mb: 6 }}>
          {sampleUsers.map((user) => (
            <Grid size={{ xs: 12, md: 6, lg: 4 }} key={user.resourceId}>
              <ContactCard user={user} size="medium" emergencyContact={showEmergencyContact} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 小尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          小尺寸卡片
        </Typography>
        <Grid container spacing={2} sx={{ mb: 6 }}>
          {sampleUsers.map((user) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={user.resourceId}>
              <ContactCard user={user} size="small" emergencyContact={showEmergencyContact} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 特殊情况展示 */}
        <Typography variant="h5" gutterBottom>
          特殊情况展示
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="subtitle1" gutterBottom>
              无电话号码用户
            </Typography>
            <ContactCard
              user={{
                ...sampleUsers[3],
                phone: null,
              }}
              emergencyContact={showEmergencyContact}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="subtitle1" gutterBottom>
              无紧急联系人
            </Typography>
            <ContactCard
              user={{
                ...sampleUsers[2],
                emergencyContact: null,
              }}
              emergencyContact={showEmergencyContact}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}
